import { useDispatch, useSelector } from "react-redux";
import { pageSelected } from "../../features/filter/filterSlice";

export default function Pagination() {
  const dispatch = useDispatch();
  const { totalVideos } = useSelector((state) => state.videos);
  const { page, limit } = useSelector((state) => state.filter);
  const handlePageSelect = (selectPage) => {
    dispatch(pageSelected(selectPage));
  };

  let totalPages = new Array(Math.ceil(totalVideos / limit)).fill();

  return (
    <section className="pt-12">
      <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
        {totalPages.map((_, index) => (
          <div
            key={index}
            onClick={() => handlePageSelect(index + 1)}
            className={`${
              index + 1 === page
                ? "bg-blue-600 text-white "
                : "bg-blue-100 text-blue-600 "
            }px-4 py-1 rounded-full cursor-pointer`}
          >
            {index + 1}
          </div>
        ))}
      </div>
    </section>
  );
}
